window.lpTag = window.lpTag || {};
lpTag.taglets = lpTag.taglets || {};
/**
 * @fileOverview Contains lpAjax request object definition
 * @author Efim Dimenstein
 * @version 0.1 - 2012-08-20
 */
/**
 * lpAjax_request namespace
 * @namespace - Contains lpAjax request object definition
 */
lpTag.taglets.lpAjax_request = {
    /**
     * The url of the request
     * @public
     * @type String
     */
    url : '',
    /**
     * The method of the request - valid options (GET/POST/PUT/DELETE) <br>
     * Optional - default value is an automatically GET <br>
     * Please note that for some transports not all methods apply
     * @public
     * @type String
     */
    method : 'GET',
    /**
     * The encoding of the request <br>
     * Optional - default value utf-8 <br>
     * Please note that for some transports not all methods apply
     * @public
     * @type String
     */
    encoding : 'utf-8',
    /**
     * If set to false, it will force requested pages not to be cached by the browser.<br>
     * Setting cache to false also appends a query string parameter, "_=[TIMESTAMP]", to the URL.
     * Optional - default value true <br>
     * Please note that for some transports not all methods apply
     * @public
     * @type String
     */
    cache : true,
    /**
     * A map of additional header key/value pairs to send along with the request.
     * Optional <br>
     * Please note that for some transports not all methods apply
     * @public
     * @type Object
     */
    headers : {},
    /**
     * An array of transport names - which specifies the order of finding the matching transport <br>
     * Optional - default []<br>
     * @public
     * @type Array
     */
    transportOrder : ['ajax', 'jsonp', 'postmessage','iframePost'],
    //    transportOrder : ['postmessage','iframePost'],

    /**
     *  An optional property that applies only to jsonp transport and specifies the name of the callback to use when issuing the request
     * Optional - default 'cb'<br>
     * @public
     * @type String
     */
    callback : 'cb',
    /**
     * Data to be sent to the server. <br>
     * It is converted to a query string, if not already a string. It's appended to the url for GET-requests.<br>
     * Deep Object for JSONP will be converted to key : encodeURIComponent(stringify(Object)) format
     * Optional <br>
     * @public
     * @type Object|String
     */
    data : {},
    /**
     * A key value object that can be added to any XHR or postMessage request <br>
     * Will be added to the query string
     */
    query: {},
    /**
     * Number of retries if the timeout is reached <br>
     * Specifies the number of retries after the request timed out
     * Optional  - default value 2 <br>
     * @public
     * @type Integer
     */
    retries : 2,
    /**
     * Set a timeout (in seconds) for the request <br>
     * Optional  - default value 30 <br>
     * @public
     * @type Integer
     */
    timeout : 30,
    /**
     * Use XML HTTP override headers for PUT/DELETE requests <br>
     * making them use post as the real method <br>
     * Optional
     */
    XMLHTTPOverride: true,
    /**
     * The sent mimeType, supported for override in modern browser
     * Options: "application/json", "text/javascript", "text/html", "application/xml", "text/xml", "application/x-www-form-urlencoded"
     * Optional
     */
    mimeType : "application/json",
    /**
     * A function to be called if the request fails. <br>
     * Optional <br>
     * @public
     * @type Function
     */
    error : function () {},
    /**
     * A function to be called if the request succeeds. <br>
     * Optional <br>
     * @public
     * @type Function
     */
    success : function () {},
    /**
     * If you want to receive progress events on XHR requests this
     * can be used if the browser supports them.
     */
    progress: function(){},
    /**
     * The context in which we want to run the success/error callbacks <br>
     * If none is provided the context will not be set (null)
     * Optional
     */
    context: {},

    init : function (cfg) {
    }
};

/*** EXPORTS FROM exports-loader ***/
module.exports = lpTag.taglets.lpAjax_request;